<template lang="pug">
    .overflow-hidden.w-24.h-24
      iCon.overflow-hidden.cursor-pointer(:iconClass="'dropdown'"  type="svg")
</template>
<script>
export default {
  name: 'SelectIcon',
  props: {
  },
}
</script>
